import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

@Injectable()
export class MenuService {

  constructor(private httpClient: HttpClient) { }

  getMenus(): Observable<Menu[]> {
    return this.httpClient.get<Menu[]>('../../../../assets/menu.json');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.service.ts